import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/recordTypes/$recordTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: OrgRecordTypeSchemaTab,
});

function OrgRecordTypeSchemaTab() {
	const { orgId, recordTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab
			entity="record"
			typeId={recordTypeId}
			scope="org"
			orgId={orgId}
			mutationOrganizationId={orgId}
		/>
	);
}
